import { success } from "App/popupMessage";
import { getAllDocuments } from "Areas/Sidebar/Documents/redux/selectors";
import compact from "lodash/compact";
import difference from "lodash/difference";
import filter from "lodash/filter";
import find from "lodash/find";
import isEqual from "lodash/isEqual";
import map from "lodash/map";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getDocumentMapData: (documentId) => ({
        type: actionTypes.GET_DOCUMENT_MAP_DATA,
        payload: {
            promise: () => api.getDocumentMapData(documentId)
        },
        meta: { documentId },
        scope: `${actionTypes.GET_DOCUMENT_MAP_DATA}_${documentId}`
    }),
    clearData: (documentId) => ({
        type: actionTypes.CLEAR_DATA,
        documentId
    }),
    saveDocumentMapData: (documentId, prevData, data) => (dispatch, getState) => {
        const document = find(getAllDocuments(getState()), ["Id", documentId]);
        if (!document)
            return undefined;
        const newSourceData = data;
        const newPointsIds = map(newSourceData.Points, "NodeId");
        const prevPointsIds = map(prevData.Points, "NodeId");
        const newGeometryIds = map(newSourceData.Geometry, "Id");
        const prevGeometryIds = map(prevData.Geometry, "Id");
        const deletedNodeIds = compact(difference(prevPointsIds, newPointsIds));
        return dispatch({
            type: actionTypes.SAVE_DOCUMENT_MAP_DATA,
            payload: {
                promise: () => api.saveDocumentMapData({
                    Id: newSourceData.Id,
                    NodesSource: compact(map(newSourceData.Points, item => {
                        const prev = find(prevData.Points, ["NodeId", item.NodeId]);
                        if (!prev || !isEqual(prev, item))
                            return item.NodeSource;
                        return undefined;
                    })),
                    DeletedGeometryIds: compact([
                        ...compact(difference(prevGeometryIds, newGeometryIds)),
                        ...deletedNodeIds
                    ]),
                    DeletedNodeIds: deletedNodeIds,
                    Geometry: compact(filter(newSourceData.Geometry, item => {
                        const prev = find(prevData.Geometry, ["Id", item.Id]);
                        return prev ? !isEqual(prev, item) : true;
                    }))
                })
            },
            meta: {
                documentId,
                sourceData: newSourceData
            },
            scope: `${actionTypes.SAVE_DOCUMENT_MAP_DATA}_${documentId}`,
            completed: (disp) => {
                disp(success(locale.buildDocumentSavedSuccessfully(document.Name)));
            },
            rejectedMessage: locale.buildDocumentSavingFailed(document.Name)
        });
    },
    addGeometry: (documentId, data) => ({
        type: actionTypes.ADD_GEOMETRY,
        documentId,
        data
    }),
    updateMapData: (documentId, data, nameUpdated, colorUpdated, pointsCoordsUpdated) => ({
        type: actionTypes.UPDATE_MAP_DATA,
        documentId,
        data,
        nameUpdated,
        colorUpdated,
        pointsCoordsUpdated
    }),
    setDetailedPanelOpen: (detailedPanelOpen) => ({
        type: actionTypes.SET_DETAILED_PANEL_OPEN,
        detailedPanelOpen
    }),
    setDeleted: (ids) => ({
        type: actionTypes.SET_DELETED,
        ids
    }),
    setMapOptions: (documentId, center, zoom) => ({
        type: actionTypes.SET_MAP_OPTIONS,
        documentId,
        center,
        zoom
    })
};
